import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import Logger from '../../../services/loggerService';

const { DISCOVERY_SAMPLE_FILE_DOWNLOAD } = getObNextGenApiUrlLists();

const FileDownloadApi = async () => {
  const FILE_DOWNLOAD_URL = `${getBaseUrlObNextGen()}${DISCOVERY_SAMPLE_FILE_DOWNLOAD}`;

  try {
    const response = await fetch(FILE_DOWNLOAD_URL, {
      method: 'GET',
      headers: {
        TENANT_ID: 'DEFAULT',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to download sample file');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', 'Sample_Discovery_Source.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    Logger.error('Download error:', error);
  }
};

export default FileDownloadApi;
